import { configureStore } from '@reduxjs/toolkit';
import themeSlice from './theme/themeSlice';
import userSlice from './user/userSlice';

export function makeStore() {
  return configureStore({
    reducer: {
      theme: themeSlice,
      user: userSlice,
    },
  });
}

const store = makeStore();

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
